module.exports = __webpack_public_path__ + "static/media/footer-logo-white.2b684b44.png";